import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { InstallAppPrompt } from '@/components/InstallAppPrompt';
import { AppProvider } from './contexts/AppProvider';
import { AuthProvider } from './contexts/AuthProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1, // Apenas 1 tentativa
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Backoff exponencial
        staleTime: 5 * 60 * 1000, // 5 minutos
        gcTime: 10 * 60 * 1000, // 10 minutos (anteriormente cacheTime)
      },
      mutations: {
        retry: 1, // Mutations com apenas 1 tentativa
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <AuthProvider>
          <BrowserRouter>
            <InstallAppPrompt />
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}

export default App;
